import type { ReactNode } from "react";
import Autolink from "react-native-autolink";

import { Link, Text } from "./Typography";

type AutolinkTextProps = {
  text: string;
  dataTrackingId: string;
  renderText?: (text: string) => ReactNode;
};

export default function AutolinkText({
  text,
  dataTrackingId,
  renderText = (text) => <Text>{text}</Text>,
}: AutolinkTextProps) {
  return (
    <Autolink
      as={Text}
      whiteSpace="pre-line"
      text={text}
      renderText={renderText}
      stripPrefix={false}
      truncate={50}
      renderLink={(text, match) => (
        <Link
          href={match.getAnchorHref()}
          external
          dataTrackingId={dataTrackingId}
        >
          {text}
        </Link>
      )}
    />
  );
}
